export default {
    header: {
        products: 'Products',
        vg: 'Video Guidence',
        download: 'Download',
        about: 'About Us'
    },
    pageTitle1: 'Make your TV',
    pageTitle2: 'smarter',
    available: 'Coming soon',
    buy: 'BUY',
    config: 'Configuration',
    os: {
        title: "More ways to play, upgraded experience",
        intro: "AuroraTV ecosystem, featuring AuroraOS developed based on Slimbox, achieves deep system network optimization and comprehensive speed enhancement. The lightweight architecture delivers smooth interactive experience!"
    },
    comment: {
        title: 'Customer Reviews',
        Subtitle: 'Hear What They Say',
        text: 'Genuine feedback from verified buyers to help you shop with confidence.'
    },
    certificate: {
        title: 'Meet the AURORA',
        text: 'The AURORA intelligent system not only offers smooth operation and personalized interfaces, but also integrates rich applications, convenient remote control and stable performance, making the TV not just a playback tool, but an intelligent entertainment center in your life.'
    },
    aurora: {
        title: 'AURORA App Ecosystem',
        mcplayer: 'MCPlayer is a streaming media player offering industry-leading sports live broadcasts, movie and TV subscriptions, supporting live events, massive on-demand video content, and TV channel streaming. MCPlayer channels and content may vary by country or region.',
        mcstore: 'McStore is an Android TV app store designed for smart TVs, providing a vast collection of licensed apps, games, and video services!'
    },
    osIntro: 'What new features does AURORATV OS offer compared to other firmware on the market?',
    osTitle: 'More',
    osSecTitle: 'Extended Features',
    extended: {
        remote: 'Custom shortcut keys',
        timezone: 'Fix Time Zone Issues',
        clean: 'One-Click Memory Cleanup',
        intro1: 'Customize remote control button functions to support multiple remote devices and integrate with the latest AURORA system for quick operations and one-touch app launching.',
        intro2: 'With just one click, easily clear TV cache to improve performance, ensure smoother operation, and maintain optimal TV efficiency.',
        intro3: 'When network restrictions or NTP server failures cause connectivity issues, instantly switch NTP servers to quickly restore network time synchronization.'
    },
    equipped: {
        title: 'Supported Models',
        buy: 'Buy',
        productParame: 'Product Specifications',
        tanix: {
            param1: 'OS: Android 11.0',
            param2: 'CPU: Amlogic S905W2 Quad Core, ARM® Cortex™-A35',
            param3: 'Storage: 4+32GB/4+64GB'
        },
        x96q: {
            param1: 'OS: Android 10.0',
            param2: 'CPU: Allwinner H313 Quad Core ARM Cortex A53',
            param3: 'Storage: 2+16GB'
        },
        aurora: {
            param1: 'OS: Android 11.0',
            param2: 'CPU: Amlogic S905W2 Quad Core, ARM® Cortex™-A35',
            param3: 'Storage: 4+32GB/4+64GB'
        },
        elite: {
            param2: 'CPU: Quad Core ARM Cortex A53',
            param3: 'Storage: 2+16GB',
            param1: 'OS: Android 10.0'
        }
    },
    remote: {
        intro: 'Control your TV with your phone anytime, anywhere - effortless and natural living at your fingertips!',
        download: 'Download Now',
        note: 'Currently only supports',
        andriod: 'Android phones',
        open_intro: 'Easily control TV apps with your phone - instantly launch favorite apps with one tap. Supports custom sorting and pinning frequently used apps for smooth, intuitive operation.',
        ipt_intro: 'Now you can input text on TV without tedious on-screen clicking - simply type in the app and send it directly to your TV.',
        file_intro: 'Upload APK files directly to your TV for app installation - much faster and more convenient than using USB drives!',
        ctl_intro: 'The Aurora Remote app lets you control your Android smart TV without needing a physical remote.',
        fbTitle: 'Pick up your phone',
        fbSecTitle: 'Open the app to control anytime',
        fbIntro: 'Works with all models - just open the app, connect to your device, and start controlling',
        more: 'More Features'
    },
    application: {
        title: 'Exclusive Application, All Event Information at Your Fingertips',
        mcstore: {
            appName: 'MCStore',
            appDesc: 'Offers over a hundred secure and reliable TV applications, which can be easily and quickly downloaded and installed, and used immediately after installation.'
        },
        mcplayer: {
            appName: 'MCPlayer',
            appDesc: 'Subscribe to watch 20,000 TV channels and 100,000 film and television series, including 3,000 sports channels. '
        }
    },
    userComment: [{
            content: 'This is my second purchase of this set-top box, it works normally, connects to the internet quickly and easily, everything is satisfactory so far, no complaints!'
        },
        {
            content: 'Excellent! Everything works right out of the box! It has both TV channels and movies! Everything works without lags or glitches'
        },
        {
            content: 'Excellent quality, everything works without problems. I really like it, apps install without any issues'
        },
        {
            content: 'Excellent set-top box, much better than what I used before, quality picture, works fast. No problems with setup'
        },
        {
            content: 'I\'m satisfied with the purchase, clients are too. I install whatever is needed, I mean the firmwares. Overall people are happy and I\'m not at a loss'
        },
        {
            content: 'I knew what I was buying - this is currently the best TV box in terms of price/quality ratio! I can confidently recommend purchasing it!'
        }
    ],
    feature: {
        specification: 'Specification',
        product: 'Product',
        x96q: {
            f: "Performance core, instant response",
            s: "Full device compatibility"
        },
        aurora: {
            f: "Quad-core A35 architecture",
            s: "Dual-band Wi-Fi 5"
        },
        tanix: {
            f: "Slimbox+ custom firmware",
            s: "Silent cooling system"
        }
    },
    videoGuidece: 'Operation questions and answers',
    videoTitle: 'Tutorial video',
    videoIntroduction1: 'Tanix W2 firmware tutorial video',
    videoIntroduction2: 'MCPlayer app tutorial video',
    videoIntroduction3: 'Bluetooth Remote Control Pairing Tutorial',
    dowmloadRemote: {
        mainDesc: 'Compatible with all Aurora TV boxes running SlimBOX+ system. Use the Aurora Remote app to easily control your TV with your smartphone! Just connect your smart TV and Aurora Remote to the same WiFi network or pair them via Bluetooth to power on/off your TV, launch apps with one click, adjust volume, and install applications!',
        dowmload: 'Download App',
        text1: 'Currently only supports',
        text2: 'Android phones',
        text3: 'version',
        title: 'AURORA TV Remote',
        secondary_title: 'Easily control your TV and unlock smarter experiences',
        quick_title: 'Quick Launch',
        quick_title_sec: 'Applications',
        quick_open_txt: 'The system automatically scans all installed TV apps while supporting personalized custom sorting. Through simple drag-and-drop, you can pin favorite apps to the top, creating dedicated quick-access shortcuts for one-tap launching.',
        file_title: 'File',
        file_secondary_title: 'Transfer',
        file_txt: 'No USB needed! Use Aurora Remote\'s file upload feature to transfer APKs to your TV box for app installation.',
        media_title: 'Responsive',
        media_secondary_title: 'Touchpad',
        media_txt: 'Navigate using directional keys or touchpad slides, just like using a physical remote to control your TV!',
        search_title: 'Fast',
        search_secondary_title: 'Text Input & Search',
        search_txt: 'Supports quick text input and search for more efficient TV operation.'
    },
    dowmloadMcstore: {
        mainDesc: 'AURORA\'s own app store platform. We provide over a hundred reliable and secure TV applications, making it easy and quick for you to download and use them.',
        dowmload: 'Download App',
        text1: 'This app is only available for',
        text2: 'Andriod TV'
    },
    about: {
        headHL: 'Hello!',
        headSub: 'We are AURORA',
        outTitle1: 'What is AURORA?',
        outIntro1: 'AURORA is an IT company and a creative lab, equipped with advanced production facilities, a vibrant community, dynamic creativity, and a culture where everyone feels valued. Since 2024, we have been committed to creating technology, smart devices, and convenient services for people. Quality Assurance',
        outTitle2: 'Quality Assurance',
        outIntro2: 'All work begins with research. Based on this, we carry out multi-dimensional conceptual development, prototype iteration, hardware architecture construction, and design validation. Throughout the process, we integrate resources from industry-leading experts, establish collaborative mechanisms with research institutions, and conduct systematic experiments and tests using advanced professional equipment. Future user needs remain the core focus throughout the entire development cycle of our devices, services, and technologies.',
        outTitle3: 'Service Guarantee',
        outIntro3: 'All AURORA set-top boxes are genuine products. From R&D and production to sales, they undergo strict quality control systems, with each product passing multiple quality inspection procedures to ensure superior quality and stable performance, delivering a reliable and premium user experience.',
        outTitle4: 'Investors',
        outIntro4Part1: 'For investor-related inquiries, please email ',
        outIntro4Part2: ' or contact us via Telegram/WhatsApp.',
        outTitle5: 'Individual Customers',
        outIntro5Part1: 'For general questions, including personal and bulk orders, pricing, logistics, payment, delivery, and return policies, please visit the ',
        outIntro5Part2: 'official OZON store',
        outIntro5Part3: ' for assistance.',
        contactHL: 'Business Cooperation',
        contactSub: 'Contact'
    },
    footer: {
        serverTitle: 'Consultation Hours:',
        serverTime: 'Monday to Friday 9:00 AM - 12:00 PM, 2:00 PM - 7:00 PM, excluding public holidays'
    }
}